import { ScaleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterRetainerSignedByAttorneyEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterRetainerSignedByAttorneyEventProps {
  event: DiscriminatedMatterRetainerSignedByAttorneyEvent;
}

export const MatterRetainerSignedByAttorneyEvent: React.FC<
  MatterRetainerSignedByAttorneyEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-indigo-100">
          <ScaleIcon className="h-4 w-4 text-indigo-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        <div className="text-sm text-gray-600">
          Attorney signed retainer agreement
        </div>
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Attorney Signed Retainer"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
